import {
    GET_CORRELATION_DETAILS_REQUEST,
    GET_CORRELATION_DETAILS_SUCCESS,
    GET_CORRELATION_DETAILS_FAILURE
} from '../actions';


const initialState = {};

const CorrelationDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CORRELATION_DETAILS_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_CORRELATION_DETAILS_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case GET_CORRELATION_DETAILS_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default CorrelationDetailsReducer